import {
  useState,
  useCallback,
  useLayoutEffect,
  useRef,
  useEffect,
  MutableRefObject,
  RefObject
} from 'react';

type RefType = HTMLDivElement;
type DOMType = DOMRect;

const useDimensions = (
  recalcOnChange?: any[]
): [RefObject<RefType>, DOMRect | undefined] => {
  const [dims, setDims] = useState<DOMRect | undefined>(undefined);

  const targetRef = useRef<RefType>(null);
  const timer = useRef<NodeJS.Timeout | undefined>(undefined);

  const div_dimensions = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      console.log('recalcing dims');
      if (!targetRef.current) {
        console.log('no target');
        return;
      }

      setDims(targetRef.current.getBoundingClientRect());
    }, 200);
  };

  useEffect(() => {
    window.addEventListener('resize', div_dimensions);
    return () => {
      window.removeEventListener('resize', div_dimensions);
    };
  }, []);

  useLayoutEffect(() => {
    div_dimensions();
  }, []);

  useLayoutEffect(() => {
    console.log('use layout');
    div_dimensions();
  }, recalcOnChange);

  return [targetRef, dims];
};

export default useDimensions;
